import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function PaiementAnnule() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-paper flex flex-col items-center justify-center px-6 text-center">
      <Link to="/" aria-label="Accueil VAV"><Logo /></Link>
      <h1 className="mt-10 font-serif text-4xl md:text-5xl tracking-tight text-ink">Paiement interrompu.</h1>
      <p className="mt-4 max-w-md text-smoke text-sm md:text-base leading-relaxed">
        Aucun montant n'a été débité. Vous pouvez reprendre votre souscription quand vous le souhaitez.
      </p>
      <div className="mt-10 flex gap-4">
        <Link data-testid="payment-cancel-espace-cta" to="/espace-client" className="rounded-full bg-ink text-paper px-8 py-4 text-sm hover:bg-sagedark transition-colors duration-300">
          Mon espace
        </Link>
        <Link data-testid="payment-cancel-tarifs-cta" to="/" className="rounded-full border border-ink/25 px-8 py-4 text-sm hover:border-ink transition-colors duration-300">
          Revoir les modules
        </Link>
      </div>
    </div>
  );
}
